// extracted by mini-css-extract-plugin
export var base = "_27-0";
export var updateBanner = "_27-1";